import { render, staticRenderFns } from "./gameStageBackview.vue?vue&type=template&id=219bed32&scoped=true&"
import script from "./gameStageBackview.vue?vue&type=script&lang=js&"
export * from "./gameStageBackview.vue?vue&type=script&lang=js&"
import style0 from "./gameStageBackview.vue?vue&type=style&index=0&id=219bed32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219bed32",
  null
  
)

export default component.exports